<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>To Maz</i></span></p>
<p class="ded1"><span><i>Newton (nee Piglet)</i></span></p>
<p class="ded1"><span><i>and</i></span></p>
<p class="ded1"><span><i>Alan Lebowitz</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6965d8a5